import styled from 'styled-components';
import { colors } from '../../tailwind';

const Select = styled.select`
  height: 48px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px ${colors.coolGrayLight};
  font-family: Helvetica;
  font-size: 19px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  width: ${props => props.width || '100%'};
  color: ${colors.primaryLight};
  padding-left: 16px;
  padding-right: 16px;

  &::placeholder {
    color: ${colors.primaryFaded};
    opacity: 0.4;
  }
`;

export default Select;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Select.js